import { musicServicesByImporterID } from 'fym-shared/src/music-services/allMusicServices';
import { integrationTypeToImporterId } from '../../components/IntegrationTypeIcon/IntegrationTypeIcon';

export interface BrowseServiceOption {
  /** The musicapi `IntegrationType`, the value the server filters on. */
  value: string;
  label: string;
}

/** The services the Service filter offers (Label plan), with the name a person recognises. */
export const BROWSE_SERVICE_OPTIONS: BrowseServiceOption[] = Object.entries(integrationTypeToImporterId)
  .map(([value, importerId]) => {
    const service = musicServicesByImporterID[importerId];
    return { value, label: service?.shortName ?? service?.name ?? value };
  })
  .sort((left, right) => left.label.localeCompare(right.label));
